import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n";
import { HashRouter as Router } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import smoothscroll from 'smoothscroll-polyfill';
import smoothscroll from "smoothscroll-polyfill";

// kick off the polyfill!
smoothscroll.polyfill();
// smoothscroll.polyfill();

/**
 * Setup router, with language and basename.
 *
 */
function AppWrapper() {
  const { i18n } = useTranslation();

  // If you want to switch language dynamically
  // may need to migrate from using basename in React Router,
  // as this doesn't trigger a re-renderr.

  return (
    <Suspense fallback="loading">
      <Router basename={"/" + i18n.language}>
        <App />
      </Router>
    </Suspense>
  );
}

ReactDOM.render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
